export const IconMap: any = {
    'in progress'      : { icon : ['pficon', 'pficon-resources-almost-full'], color :  '#ec7a08' },
    'new'              : { icon : ['fa', 'fa-star'], color : '#582fc0' },
    'resolved'         : { icon : ['pficon', 'pficon-resources-full'], color : '#3f9c35' },
    'open'             : { icon : ['fa', 'fa-fire'], color : '#cc0000' },
    'closed'           : { icon : ['fa', 'fa-remove'], color : '#72767b' },
    'userstory'        : { icon : ['fa', 'fa-bookmark'], color : '#000000' },
    'valueproposition' : { icon : ['fa', 'fa-gift'], color : '#000000' },
    'fundamental'      : { icon : ['fa', 'fa-bank'], color : '#000000' },
    'experience'       : { icon : ['fa', 'fa-map'], color : '#000000' },
    'feature'          : { icon : ['fa', 'fa-mouse-pointer'], color : '#000000' },
    'bug'              : { icon : ['fa', 'fa-bug'], color : '#000000' },
    'planneritem'      : { icon : ['fa', 'fa-paint-brush'], color : '#000000' },
    'default'          : { icon : ['fa', 'fa-crosshairs'], color : '#000000' } // Never remove this line
};
